import {
  authService,
  appService,
  notificationsService,
  reportsService,
  goalsService,
  taskManagementService,
  humanResourcesService,
  checklistService,
  shiftsService,
  commissionsService,
  shiftService,
  statsService,
  shiftAdminService,
  companyService,
} from './insightt-services';

const create = () => ({
  // AUTH
  ...authService,
  // APP
  ...appService,
  // Notifications
  ...notificationsService,
  // Reports
  ...reportsService,
  // Goals
  ...goalsService,
  // Task Management
  ...taskManagementService,
  // User
  ...humanResourcesService,
  // Checklist
  ...checklistService,
  // Manage Shifts
  ...shiftsService,
  // Commissions
  ...commissionsService,
  // Shift
  ...shiftService,
  // Stats
  ...statsService,
  // Shift Admin
  ...shiftAdminService,
  // Company data
  ...companyService,
});

export default {
  create,
};
